<svg class="{$$props.class}" viewBox="0 0 448 512">
  <path
    fill="currentColor"
    d="M416 32H31.9A32.1 32.1 0 000 64.3v383.4A32.1 32.1 0 0031.9 480H416c17.6 0
    32-14.5 32-32.3V64.3A32.2 32.2 0 00416 32zM135.4
    416H69V202.2h66.5V416zm-33.2-243a38.5 38.5 0 110-77 38.5 38.5 0 010
    77zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9
    54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7
    44.3 79.7 101.9V416z" />
</svg>
